// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PersonInfo-module__personInfo--vR9Hq {
    display: flex;
    flex-direction: column;
    margin-top: 30px;
    padding: 15px 20px;
    border-radius: 14px;
    -webkit-box-shadow: -1px 5px 22px 2px rgba(34, 60, 80, 0.11);
    -moz-box-shadow: -1px 5px 22px 2px rgba(34, 60, 80, 0.11);
    box-shadow: -1px 5px 22px 2px rgba(34, 60, 80, 0.11);
    gap: 15px;
    min-height: 40vh;
    background-color: white;
    overflow: hidden;
}

.PersonInfo-module__rightBox--Jlc0k {
    width: 100%;
   
}
.PersonInfo-module__leftBox--yjxfS {
    width: 100%;
    margin-top: 10px;
}

.PersonInfo-module__itemRow--m_ARh {
    display: flex;
    gap: 100px;
    margin-top: 10px;
    border-bottom: 1px solid #6f879c4b;
    width: 98%;
}
.PersonInfo-module__itemRow--m_ARh:not(:first-child) {
    margin-top: 30px; 
}

.PersonInfo-module__itemColumn--SroeG > span {
    color: #6F879C;
    font-size: 16px;
}

.PersonInfo-module__itemColumn--SroeG > p {
    font-weight: 500;
    color: #516372;
    margin-top: 5px;
    font-size: 18px;
}

.PersonInfo-module__leftBox--yjxfS > .PersonInfo-module__itemColumn--SroeG {
    margin-top: 10px;
    border-bottom: 1px solid #6f879c4b;
}
.PersonInfo-module__leftBox--yjxfS > .PersonInfo-module__itemColumn--SroeG:not(:first-child) {
    margin-top: 50px;
}`, "",{"version":3,"sources":["webpack://./src/features/insured-person-case/ui/PersonInfo.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,4DAA4D;IAC5D,yDAAyD;IACzD,oDAAoD;IACpD,SAAS;IACT,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,WAAW;;AAEf;AACA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,UAAU;IACV,gBAAgB;IAChB,kCAAkC;IAClC,UAAU;AACd;AACA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,kCAAkC;AACtC;AACA;IACI,gBAAgB;AACpB","sourcesContent":[".personInfo {\r\n    display: flex;\r\n    flex-direction: column;\r\n    margin-top: 30px;\r\n    padding: 15px 20px;\r\n    border-radius: 14px;\r\n    -webkit-box-shadow: -1px 5px 22px 2px rgba(34, 60, 80, 0.11);\r\n    -moz-box-shadow: -1px 5px 22px 2px rgba(34, 60, 80, 0.11);\r\n    box-shadow: -1px 5px 22px 2px rgba(34, 60, 80, 0.11);\r\n    gap: 15px;\r\n    min-height: 40vh;\r\n    background-color: white;\r\n    overflow: hidden;\r\n}\r\n\r\n.rightBox {\r\n    width: 100%;\r\n   \r\n}\r\n.leftBox {\r\n    width: 100%;\r\n    margin-top: 10px;\r\n}\r\n\r\n.itemRow {\r\n    display: flex;\r\n    gap: 100px;\r\n    margin-top: 10px;\r\n    border-bottom: 1px solid #6f879c4b;\r\n    width: 98%;\r\n}\r\n.itemRow:not(:first-child) {\r\n    margin-top: 30px; \r\n}\r\n\r\n.itemColumn > span {\r\n    color: #6F879C;\r\n    font-size: 16px;\r\n}\r\n\r\n.itemColumn > p {\r\n    font-weight: 500;\r\n    color: #516372;\r\n    margin-top: 5px;\r\n    font-size: 18px;\r\n}\r\n\r\n.leftBox > .itemColumn {\r\n    margin-top: 10px;\r\n    border-bottom: 1px solid #6f879c4b;\r\n}\r\n.leftBox > .itemColumn:not(:first-child) {\r\n    margin-top: 50px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"personInfo": `PersonInfo-module__personInfo--vR9Hq`,
	"rightBox": `PersonInfo-module__rightBox--Jlc0k`,
	"leftBox": `PersonInfo-module__leftBox--yjxfS`,
	"itemRow": `PersonInfo-module__itemRow--m_ARh`,
	"itemColumn": `PersonInfo-module__itemColumn--SroeG`
};
export default ___CSS_LOADER_EXPORT___;
